import { render, staticRenderFns } from "./LeadTags.vue?vue&type=template&id=220d6d54&"
import script from "./LeadTags.vue?vue&type=script&lang=js&"
export * from "./LeadTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports